<script>
  export let message;
</script>

<style>
  p {
    text-align: center;
    font-size: 0.9em;
    padding-top: 2em;
    padding-bottom:2em;
  }
</style>

<p>
  {message}
</p>